<template>
  <b-field :label="t('MemberEmail')">
    <b-input
      expanded
      type="email"
      v-model="memberEmail"
      :placeholder="canEdit ? t('MemberEmailInput') : ''"
      :disabled="canEdit === false"
      :validation-message="t('FieldIsInvalid', { fieldName: t('MemberEmail') })"
      data-test-id="memberEmail"
      ref="memberEmailRef"
    />
  </b-field>
</template>

<script setup lang="ts">
import { ref, computed } from 'vue'
import { useI18n } from 'vue-i18n'

const props = defineProps<{
  modelValue?: string
  canEdit: boolean
}>()

const emit = defineEmits<{
  (e: 'update:modelValue', value: string | undefined): void
}>()

const { t } = useI18n()

const memberEmail = computed({
  get: () => props.modelValue,
  set: (value) => emit('update:modelValue', value)
})

const memberEmailRef = ref<{ checkHtml5Validity: () => boolean } | null>(null)

const checkHtml5Validity = (): boolean | undefined => {
  return memberEmailRef.value?.checkHtml5Validity()
}

defineExpose({
  checkHtml5Validity
})
</script>
